import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const WarningCircleFilledIcon = memo(() => (
    <IconWrapper>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M12 16.3q.212 0 .356-.143a.48.48 0 0 0 .144-.356.48.48 0 0 0-.144-.357.48.48 0 0 0-.356-.143.48.48 0 0 0-.356.143.48.48 0 0 0-.144.357q0 .212.144.356a.48.48 0 0 0 .356.144m0-3.1q.15 0 .25-.1a.34.34 0 0 0 .1-.25v-5.3q0-.147-.101-.248a.34.34 0 0 0-.25-.101q-.15 0-.25.1a.34.34 0 0 0-.1.25v5.3q0 .148.102.25.1.1.25.1m.004 7.5a8.5 8.5 0 0 1-3.393-.684 8.8 8.8 0 0 1-2.764-1.859 8.8 8.8 0 0 1-1.861-2.76 8.5 8.5 0 0 1-.686-3.392q0-1.804.685-3.393a8.8 8.8 0 0 1 1.858-2.764 8.8 8.8 0 0 1 2.761-1.861 8.5 8.5 0 0 1 3.392-.686q1.803 0 3.393.685a8.8 8.8 0 0 1 2.764 1.858 8.8 8.8 0 0 1 1.861 2.761 8.5 8.5 0 0 1 .686 3.391 8.5 8.5 0 0 1-.685 3.394 8.8 8.8 0 0 1-1.859 2.764 8.8 8.8 0 0 1-2.76 1.861 8.5 8.5 0 0 1-3.392.686"
            />
        </svg>
    </IconWrapper>
));
